import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import DashboardLayout from './components/layout/DashboardLayout';
import PublicLayout from './components/layout/PublicLayout';
import LoginPage from './pages/LoginPage';

import HomePage from './pages/public/HomePage';
import PortfolioPage from './pages/public/PortfolioPage';
import ServicesPage from './pages/public/ServicesPage';
import CareersPage from './pages/public/CareersPage';
import ContactPage from './pages/public/ContactPage';

import DashboardHome from './pages/admin/DashboardHome';
import WebsiteManagement from './pages/admin/WebsiteManagement';
import ProjectsPage from './pages/admin/ProjectsPage';
import EmployeesPage from './pages/admin/EmployeesPage';
import RecruitmentPage from './pages/admin/RecruitmentPage';
import ClientsPage from './pages/admin/ClientsPage';
import ContactsPage from './pages/admin/ContactsPage';
import FinancePage from './pages/admin/FinancePage';
import DocumentsPage from './pages/admin/DocumentsPage';
import MeetingsPage from './pages/admin/MeetingsPage';
import SettingsPage from './pages/admin/SettingsPage';
import TeamChatPage from './pages/admin/TeamChatPage';
import AttendancePage from './pages/admin/AttendancePage';
import TasksPage from './pages/admin/TasksPage';
import ApprovalsPage from './pages/admin/ApprovalsPage';

import { AuthProvider, useAuth } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import Toast from './components/ui/Toast';

function ProtectedRoute({ children }) {
  const { user, authReady } = useAuth();
  if (!authReady) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a', color: '#888' }}>
        Loading…
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <>
      <Toast />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route path="/admin" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<DashboardHome />} />
          <Route path="website"    element={<WebsiteManagement />} />
          <Route path="projects"   element={<ProjectsPage />} />
          <Route path="employees"  element={<EmployeesPage />} />
          <Route path="recruitment"element={<RecruitmentPage />} />
          <Route path="clients"    element={<ClientsPage />} />
          <Route path="contacts"   element={<ContactsPage />} />
          <Route path="finance"    element={<FinancePage />} />
          <Route path="documents"  element={<DocumentsPage />} />
          <Route path="meetings"   element={<MeetingsPage />} />
          <Route path="chat"       element={<TeamChatPage />} />
          <Route path="attendance" element={<AttendancePage />} />
          <Route path="tasks"      element={<TasksPage />} />
          <Route path="approvals"  element={<ApprovalsPage />} />
          <Route path="settings"   element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AppProvider>
    </AuthProvider>
  );
}
